import { wrap } from "lodash";

export const getFS = () => window.FS;

export const trackFSEvent = (eventName: string, safely: boolean = false) => {
    if (getFS()) {
        getFS().event(eventName);
    } else if (safely) {
        window._fs_ready = wrap(window._fs_ready, function (prev, ...args) {
            getFS().event(eventName);
            prev?.(...args);
        });
    }
};
